module.exports = __webpack_public_path__ + "static/media/Amirah Jones_1699528218913.d836f7f4.png";